import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../styles/carousel.css";

const CounselorSlides = ({ slides, maxWidth, maxHeight }) => {

  return (
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        loop={true}
        style={{ maxWidth, maxHeight, overflow: "hidden", width: "100%" }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
            maxWidth: "100%", // Full width on small screens
          },
          1024: {
            maxWidth, // Use prop value on larger screens
          },
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide
            key={`slide-${index}`}
            style={{ maxWidth, maxHeight, overflow: "hidden", width: "100%" }}
          >
            {slide}
          </SwiperSlide>
        ))}
      </Swiper>
  );
};

export default CounselorSlides;
